export default {
  en: {
    DELETE_CALL_FLOW_NODE_CONFIRMATION_TITLE: 'Delete Node',
    DELETE_CALL_FLOW_CONFIRMATION_TITLE: 'Delete Call Flow',
    DELETE_CALL_FLOW_MODAL_CHECK_ASSOCIATION_TEXT: 'Determining if <strong>{callFlowTreeToDeleteName}</strong> is currently associated with any campaigns.',
    DELETE_CALL_FLOW_MODAL_ASSOCIATION_TEXT: 'Are you sure you want to delete?<br/><br/><strong>{callFlowTreeToDeleteName}</strong> is currently associated with the following campaigns:',
    DELETE_CALL_FLOW_MODAL_NONE_ASSOCIATION_TEXT: '<strong>{callFlowTreeToDeleteName}</strong> is not associated with any Campaigns.',
    DELETE_CALL_FLOW_MODAL_CHECK_ASSOCIATION_ERROR_TEXT: 'An error occurred while determining associated Campaigns, please try again.',
    DELETE_CALL_FLOW_ATTEST: 'I understand that deleting this Call Flow will activate the last used route on the Campaigns listed above.',
    DELETE_CALL_FLOW_SUCCESS_MESSAGE: 'Call Flow Tree successfully deleted',
    NO_ROUTE_SETUP_WARNING: 'No route setup besides this Call Flow',
    SEARCH_CALL_FLOWS: 'Search Call Flows',
    CALL_FLOWS_TABLE_LOADING: 'Loading Call Flows',
    CALL_FLOWS_SCENE_ERROR: 'One or more Nodes failed validation',
    ATTACH_NODE_ERROR_MESSAGE: 'An error occurred attempting to add node, please try again.',
    UPDATE_NODE_ERROR_MESSAGE: 'An error occurred attempting to update node, please try again.',
    BUTTON_ALL_CALL_FLOWS: 'All Call Flows',
    BUTTON_CREATE_CALL_FLOW: 'Create Call Flow',
    CALL_PLANS_VIEW_SELECTED: 'View Selected Call Plan',
    CALL_PLANS_REFRESH: 'Refresh Call Plans',
    DIAL_NODE_PLAY_URL_TOOLTIP: 'Select or upload an audio file to playback. Only the following are supported:<br/><br/>MP3: MPEG ADTS, layer III, v1, 128 kbps, 44.1 kHz, JntStereo<br/><br/>WAV: WAVE PCM, 8,000 Hz 16 bit or 11,025 Hz 16 bit PCM',
    DIAL_NODE_PLAY_URL: 'Select file',
    DIAL_NODE_UPLOAD_AUDIO: 'Upload .mp3 or .wav file.',
    DIAL_NODE_UPLOAD_SUCCESS: 'File uploaded successfully. Please make a test call to verify your call flow is working properly.',
    ROUTER_NODE_FILTER_CRITERIA: 'Route Filter Criteria',
    BUTTON_ADD_ROUTE: 'Add Route',
    STATUS_DRAFT: 'Draft',
    STATUS_LIVE: 'Live',
    VERSION_LEGACY: 'Legacy',
    VERSION_LEGACY_TOOLTIP: 'Created in the IVR editor. If updates are applied within the Call Flow, it will no longer be available in the IVR editor.',
    VERSION_CALL_FLOW: 'Call Flow',
    SAVE_CALL_FLOW_SUCESS: 'Call Flow Published',
    SAVE_CALL_FLOW_ERROR: 'Error Publishing Call Flow',
    SAVE_DRAFT_SUCESS: 'Call Flow Draft Saved',
    SAVE_DRAFT_ERROR: 'Error Saving Call Flow Draft',
    SELECT_NODE: 'Select Node',
    EDIT_SELECTED_NODE: 'Edit Selected Node',
    NODE_SELECTION: 'Node Selection',
    CALL_FLOW_IN_USE_TITLE: 'Call Flow is in use',
    CLONE_AND_SAVE: 'Clone and Save',
    SAVE_AND_PUBLISH: 'Save and Publish',
    SAVE_FLOW_DRAFT_MODAL_ASSOCIATION_TEXT: 'This call flow is being used in live campaigns, it can\'t be reverted to a draft. You may save a clone of this call flow as a draft instead.',
    SAVE_FLOW_MODAL_ASSOCIATION_TEXT: 'This call flow is being used in live campaigns. Publishing the changes will apply to the following campaigns.',
    CALL_FLOW_UNLOAD_CONFIRMATION: 'You may have unsaved changes to the call flow, are you sure you want to leave and discard your changes?',
    MENU_ROUTES: 'Menu Routes',
    SPLIT_TEST_ROUTES: 'Split Test Routes',
    ROUTER_ROUTES: 'Routes',
    ROUTER_ADD_ROUTE: 'Add Route',
    ROUTER_NO_ROUTES: 'No routes have been added',
    SPLIT_TEST_LINK_SETTING_FILTER: 'Route Name',
    SPLIT_TEST_LINK_SETTINGSPLIT_TEST_FILTER_TT: 'Value of the reporting tag if this route is selected.',
    SPLIT_TEST_LINK_SETTING_WEIGHT: 'Weight',
    SPLIT_TEST_LINK_SETTING_WEIGHT_TT: 'The weight decides how often a route will be selected, a higher weight will lead to a higher probability of the route being selected.',
    UNAVAILABLE_NODE: '<strong>{unavailableNodeName}</strong> is unavailable. The Call Flow may not operate as expected until node is deleted.',
    ERROR_MUST_HAVE_VALUE: 'must have value',
    ERROR_OUT_OF_RANGE: 'number out of range',
    ERROR_FILE_EXTENSION: 'File format not supported. File must be .mp3 or .wav format.',
    PROMPT_MESSAGE: 'Voice Prompt',
    DEFAULT_PROMPT_ZIPCODE: 'Hello, thank you for calling. Could you please tell me your 5 digit zip code to continue with this call?',
    DEFAULT_PROMPT_AGE: 'Hello, thank you for calling. Could you please tell me your age to proceed with this call?',
    VOICE_RESPONSE_ENABLED: 'Voice Response Enabled',
    AUDIO_COMPONENT_SAY: 'Say'
  }
};